/* ==========================================================================
   HUSSIENI HOME — Local currency display

   The store sells in EGP only (Shopify cannot present other currencies
   without Shopify Payments), so prices are converted for display in the
   visitor's own currency and every order is still charged in EGP. The
   currency notes beside prices and the cart say so, and the cart shows the
   exact EGP amount that checkout will charge.

   Which currency:
     1. the visitor's own choice from the currency menu (remembered here),
     2. the storefront country they picked in "Ship to", if not Egypt,
     3. the country Shopify detects for the visitor
        (/browsing_context_suggestions.json), remembered for the session,
     4. otherwise EGP — nothing is converted.

   Rates: Shopify's own daily table (cdn.shopify.com/s/javascripts/currencies.js).

   How: every "LE 1,234.00" on the page (cards, product, cart, drawer, quick
   view, search, anything added later) is replaced in place by the
   converted amount; the original stays in data-hh-egp so it can be put back
   when the visitor switches back to EGP.
   ========================================================================== */
(function () {
  'use strict';

  var BASE = 'EGP';
  var RATES_URL = 'https://cdn.shopify.com/s/javascripts/currencies.js';
  var root = document.documentElement;
  if (root.hasAttribute('data-hh-cur-off')) return;

  var EU = 'AT BE CY DE EE ES FI FR GR HR IE IT LT LU LV MT NL PT SI SK'.split(' ');
  var MAP = { EG: 'EGP', SA: 'SAR', AE: 'AED', KW: 'KWD', QA: 'QAR', BH: 'BHD', OM: 'OMR', JO: 'JOD',
              US: 'USD', CA: 'CAD', GB: 'GBP', AU: 'AUD', NZ: 'NZD', CH: 'CHF', TR: 'TRY', MA: 'MAD',
              SE: 'SEK', NO: 'NOK', DK: 'DKK', PL: 'PLN', CZ: 'CZK', HU: 'HUF', JP: 'JPY', CN: 'CNY',
              IN: 'INR', SG: 'SGD', HK: 'HKD', ZA: 'ZAR', MX: 'MXN', BR: 'BRL' };
  EU.forEach(function (c) { MAP[c] = 'EUR'; });
  var MENU = ['EGP', 'SAR', 'AED', 'KWD', 'QAR', 'BHD', 'OMR', 'USD', 'EUR', 'GBP'];

  /* "LE 6,500.00", "LE 6,500", "LE 6,500.00 EGP" — the shop's money formats. */
  var PRICE = /LE\s?(\d{1,3}(?:,\d{3})*(?:\.\d{1,2})?|\d+(?:\.\d{1,2})?)(?:\s?EGP)?/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, OPTION: 1, SELECT: 1, TEMPLATE: 1 };

  var state = { code: BASE, rates: null, auto: null };
  var lang = (root.lang || 'en').slice(0, 2);
  var nfLocale = lang === 'ar' ? 'ar-u-nu-latn' : 'en';

  function store(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function sread(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function swrite(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  function fmt(amount, code) {
    var digits = amount >= 100 ? 0 : 2;
    try {
      return new Intl.NumberFormat(nfLocale, { style: 'currency', currency: code, currencyDisplay: 'code', maximumFractionDigits: digits, minimumFractionDigits: 0 })
        .format(amount).replace(/ /g, ' ');
    } catch (e) {
      return code + ' ' + Math.round(amount).toLocaleString('en');
    }
  }

  function convertValue(egp) {
    var r = state.rates;
    return egp * r[BASE] / r[state.code];
  }

  function excluded(node) {
    var el = node.nodeType === 1 ? node : node.parentElement;
    return !el || !!el.closest('[data-hh-keep-egp], .hh-cur, script, style');
  }

  /* Replace every price in the text nodes under `scope`. */
  function convertIn(scope) {
    if (state.code === BASE || !state.rates) return;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('LE') === -1) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        if (!p || SKIP[p.tagName] || excluded(n)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var text = n.nodeValue;
      PRICE.lastIndex = 0;
      if (!PRICE.test(text)) return;
      PRICE.lastIndex = 0;
      var frag = document.createDocumentFragment();
      var last = 0, m;
      while ((m = PRICE.exec(text))) {
        if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var egp = parseFloat(m[1].replace(/,/g, ''));
        var span = document.createElement('span');
        span.className = 'hh-cur';
        span.setAttribute('data-hh-egp', m[0]);
        span.setAttribute('title', m[0]);
        span.textContent = isNaN(egp) ? m[0] : fmt(convertValue(egp), state.code);
        frag.appendChild(span);
        last = m.index + m[0].length;
      }
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      n.parentNode.replaceChild(frag, n);
    });
  }

  function restoreAll() {
    document.querySelectorAll('.hh-cur[data-hh-egp]').forEach(function (s) {
      s.replaceWith(document.createTextNode(s.getAttribute('data-hh-egp')));
    });
  }

  function cartNote() {
    var total = document.querySelector('.cart__summary-total-price .hh-cur, .cart-drawer .totals .hh-cur');
    document.querySelectorAll('[data-hh-fx-note]').forEach(function (note) {
      if (state.code === BASE) return;
      note.hidden = false;
      if (note.classList.contains('hh-fx-note--cart') && total) {
        note.setAttribute('data-hh-keep-egp', '');
        note.textContent = (window.hhCurStrings && window.hhCurStrings.cart || 'Shown in {cur} at today’s rate. Checkout charges {egp}.')
          .replace('{cur}', state.code).replace('{egp}', total.getAttribute('data-hh-egp'));
      }
    });
  }

  function apply() {
    restoreAll();
    root.setAttribute('data-hh-currency', state.code);
    if (state.code !== BASE && state.rates) convertIn(document.body);
    cartNote();
    syncMenus();
    document.dispatchEvent(new CustomEvent('hh:currency', { detail: state.code }));
  }

  /* Prices added or rewritten later (quick view, cart updates, search). */
  var pending = false;
  var mo = new MutationObserver(function (records) {
    if (state.code === BASE || !state.rates || pending) return;
    var touched = records.some(function (r) {
      return !(r.target.closest && r.target.closest('.hh-cur'));
    });
    if (!touched) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      mo.disconnect();
      convertIn(document.body);
      cartNote();
      observe();
    });
  });
  function observe() { mo.observe(document.body, { childList: true, subtree: true, characterData: true }); }

  function loadRates(cb) {
    if (window.Currency && window.Currency.rates && window.Currency.rates[BASE]) { cb(window.Currency.rates); return; }
    var s = document.createElement('script');
    s.src = RATES_URL;
    s.async = true;
    s.onload = function () { cb(window.Currency && window.Currency.rates); };
    s.onerror = function () { cb(null); };
    document.head.appendChild(s);
  }

  function detectCountry(cb) {
    var chosen = root.getAttribute('data-hh-country');
    if (chosen && chosen !== 'EG') { cb(chosen); return; }
    var cached = sread('hh-geo');
    if (cached) { cb(cached === '-' ? null : cached); return; }
    fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        c = c ? String(c).toUpperCase() : null;
        swrite('hh-geo', c || '-');
        cb(c);
      })
      .catch(function () { cb(null); });
  }

  function setCode(code, remember) {
    if (remember) store('hh-currency', code === 'auto' ? null : code);
    var target = code === 'auto' ? (state.auto || BASE) : code;
    if (target === BASE) { state.code = BASE; apply(); return; }
    loadRates(function (rates) {
      if (!rates || !rates[BASE]) { state.code = BASE; apply(); return; }
      state.rates = rates;
      state.code = rates[target] ? target : 'USD';
      apply();
    });
  }

  /* Currency menus ([data-hh-cur-select]) in the footer and mobile menu. */
  function syncMenus() {
    document.querySelectorAll('[data-hh-cur-select]').forEach(function (sel) {
      if (!sel.options.length) {
        var auto = document.createElement('option');
        auto.value = 'auto';
        sel.appendChild(auto);
        MENU.forEach(function (c) { var o = document.createElement('option'); o.value = c; o.textContent = c; sel.appendChild(o); });
        sel.addEventListener('change', function () { setCode(sel.value, true); });
      }
      sel.options[0].textContent = (sel.getAttribute('data-auto-label') || 'Auto') + ' (' + (state.auto || BASE) + ')';
      sel.value = read('hh-currency') || 'auto';
    });
  }

  function start() {
    observe();
    detectCountry(function (country) {
      state.auto = country ? (MAP[country] || 'USD') : BASE;
      setCode(read('hh-currency') || 'auto', false);
    });
  }

  window.hhCurrency = { set: function (c) { setCode(c, true); }, get: function () { return state.code; } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
